/*
 * Copyright (c) 2018.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 2-10-2017
 * Time: 16:31
 *
 */

angular.module('sihw.confirm', [
    'ui.bootstrap'
    ])
    .factory('sihwconfirm', ['$uibModal',function ($uibModal) {
        /*
         * @function sihwconfirm
         * @param titel
         * @param tekst
         * @param [confirmtekst]
         * @param [canceltekst]
         * @param [windowClass] extra windowclasses
         * @param [confirmdelay] aantal ms vertraging voordat ok mag
         * @returns Promise van boolean
         */
        return (function (title, tekst, confirmtekst, canceltekst, windowClass, confirmdelay) {

            let nobutton = (canceltekst !== false);
            return $uibModal.open({
                animation: true,
                windowClass:`sihwconfirm ${nobutton ? 'confirm' : 'alert'} ${windowClass || ''}`,
                backdrop: 'static',
                template: template(),
                controller: [
                    '$scope','$uibModalInstance','$timeout',function($scope,$uibModalInstance,$timeout)
                    {
                        $scope.nobutton = nobutton;

                        //okdelay?
                        if (confirmdelay)
                        {
                            //vertraging
                            $scope.confirmdisabled = true;
                            $timeout(function() { $scope.confirmdisabled = false;}, confirmdelay);
                        }
                        else {
                            $scope.confirmdisabled = false;
                        }
                       $scope.ok = function() {
                            $uibModalInstance.close();
                        };
                        $scope.cancel = function() {
                           $uibModalInstance.dismiss();
                        }
                    }
                ]
            }).result.then(function() {
                return true;
            }).catch(function(err) {
                return false; //we rejecten nooit
            });


            function template()
            {
                return `<div class="modal-header"><h3 class="modal-title">${title}</h3></div>
                    <div class="modal-body">${tekst}</div>
                    <div class="modal-footer" ng-class="{twobuttons: nobutton, onebutton: ! nobutton}">
                    <button class="btn" ng-disabled="confirmdisabled" ng-class="{'pull-left': nobutton, 'yes': nobutton, 'center-block': ! nobutton, 'ok': ! nobutton}" ng-click="ok()" ng-attr-autofocus="{{nobutton ? undefined : true}}">${confirmtekst || "Ja"}</button>
                    <button ng-if="nobutton" class="btn pull-right no" ng-click="cancel()" autofocus>${canceltekst || "Nee"}</button>
                    </div>`;
            }
        });
    }]);
